import { colors } from "@mui/material";


export const MyColors={
     blue: {
      text: "text-blue-600",
      dark_text: "text-blue-600",

      icon_bg: "bg-blue-600/20",
      progress_bg: "bg-blue-600",
      border: "border-blue-600/30",
      hover: "hover:bg-blue-600/10",
    },
    green: {
      text: "text-green-600",
      icon_bg: "bg-green-600/20",
      progress_bg: "bg-green-600",
      border: "border-green-600/30",
      hover: "hover:bg-green-600/10",
    },
    red: {
      text: "text-red-600",
      icon_bg: "bg-red-600/20",
      border: "border-red-600/20",
      progress_bg: "border-red-600/30",
      hover: "hover:bg-red-600/10",
    },

      orange: {
      text: "text-orange-300",
      icon_bg: "bg-orange-600/20",
      progress_bg: "bg-orange-600",
      border: "border-orange-600/30",
      hover: "hover:bg-orange-600/10",
    },
    gray: {
      text: "text-gray-600",
      icon_bg: "bg-gray-600/20",
      progress_bg: "bg-gray-600",
      border: "border-gray-600/30",
      hover: "hover:bg-gray-600/10",
    },
    yellow: {
      text: "text-yellow-500",
      icon_bg: "bg-yellow-500/20",
      progress_bg: "bg-yellow-500",
    },
    purple: {
      text: "text-purple-600",
      icon_bg: "bg-purple-600/20",
      progress_bg: "bg-purple-600",
      border: "border-purple-600/30",
      hover: "hover:bg-purple-600/10",
    },
};